import React, { useEffect } from 'react'

interface PageMetadataProps {
    title?: string
    description?: string
    favicon?: string
}

export function PageMetadata({ title, description, favicon }: PageMetadataProps) {
    useEffect(() => {
        // Update document title
        if (title) {
            document.title = title
        }

        // Update meta description
        if (description) {
            let descriptionMeta = document.querySelector('meta[name="description"]')
            if (!descriptionMeta) {
                descriptionMeta = document.createElement('meta')
                descriptionMeta.setAttribute('name', 'description')
                document.head.appendChild(descriptionMeta)
            }
            descriptionMeta.setAttribute('content', description)
        }

        // Update favicon
        if (favicon) {
            let faviconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement
            if (!faviconLink) {
                faviconLink = document.createElement('link')
                faviconLink.rel = 'icon'
                document.head.appendChild(faviconLink)
            }
            faviconLink.href = favicon
        }
    }, [title, description, favicon])

    // For React 19+ compatibility, render meta tags that get hoisted to head
    if (React.version >= '19') {
        return (
            <>
                {title && <title>{title}</title>}
                {description && <meta name="description" content={description} />}
                {favicon && <link rel="icon" href={favicon} />}
            </>
        )
    }

    // For older React versions, use useEffect approach
    return null
}
